<template>
  <modal name="modal-edit-cost-matrix" height="auto" :width="560"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>{{ record?'EDIT':'ADD' }} RECORD</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <form method="post" @submit.prevent="doSave" v-if="postData">
      <div class="form-group">
        <label>Category <span class="text-danger">*</span></label>
        <v-select v-model="postData.category_id" :options="allCategories" class="form-control" :reduce="item => item.id"
                  label="name" :searchable="false" placeholder="- Select category"></v-select>
      </div>
      <div class="form-group">
        <label for="description">Task/Details <span class="text-danger">*</span></label>
        <input type="text" name="description" id="description"
               :class="{'form-control': true, 'is-invalid': errors.has('description')}"
               v-validate.disable="{ required: true }"
               v-model="postData.description">
        <div class="invalid-feedback">{{ errors.first('description') }}</div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="cost">{{ postData.sell_basis == 'quantity'?'Unit Cost':'Cost' }}</label>
          <input type="text" name="cost" id="cost" class="form-control" v-model="postData.cost">
        </div>
        <div class="form-group col">
          <label>Sell Basis <span class="text-danger">*</span></label>
          <v-select v-model="postData.sell_basis" :options="sellBasisOpts" class="form-control" :reduce="item => item.code"
                    label="name" :searchable="false" :clearable="false"  placeholder="- Select"></v-select>
        </div>
      </div>
      <div class="form-group">
        <label for="xero_code">Xero Code</label>
        <input type="text" name="xero_code" id="xero_code" :class="{'form-control': true}" v-model="postData.xero_code">
      </div>
      <h6>SELL RATES</h6>
      <div class="row">
        <div class="form-group col">
          <label for="sell_tier1">Tier 1</label>
          <input type="text" name="sell_tier1" id="sell_tier1" class="form-control" v-model="postData.sell_tier1">
        </div>
        <div class="form-group col">
          <label for="sell_tier1">Tier 2</label>
          <input type="text" name="sell_tier1" id="sell_tier2" :class="{'form-control': true}" v-model="postData.sell_tier2">
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="sell_tier3">Tier 3</label>
          <input type="text" name="sell_tier3" id="sell_tier3" :class="{'form-control': true}" v-model="postData.sell_tier3">
        </div>
        <div class="form-group col">
          <label for="sell_tier4">Tier 4</label>
          <input type="text" name="sell_tier4" id="sell_tier4" :class="{'form-control': true}" v-model="postData.sell_tier4">
        </div>
      </div>
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Save Changes</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import ServiceCostMatrix from '@/services/costmatrix'

export default {
  components: {
    BeatLoader
  },
  data () {
    return {
      state: '',
      postData: false
    }
  },
  props: ['value', 'record'],
  computed: mapState({
    allCategories: state => state.option.costCategories,
    sellBasisOpts: state => state.option.sellBasisOpts,
  }),
  watch: {
    record: 'init',
    value ( newVal ) {
      if ( newVal ) {
        this.$modal.show('modal-edit-cost-matrix', {});
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.resetForm();
      if ( !self.record ) {
        return;
      }
      for(let field in self.postData){
        if(typeof self.record[field] != "undefined"){
          self.postData[field] = self.record[field];
        }
      }
    },
    resetForm () {
      let self = this;
      self.postData = {
        category_id: '',
        sell_basis: 'quantity',
        cost: '',
        sell_tier1: '',
        sell_tier2: '',
        sell_tier3: '',
        sell_tier4: '',
        xero_code: '',
        description: ''
      };
    },
    closeModal () {
      this.resetForm();
      this.$emit('close-modal');
      this.$modal.hide('modal-edit-cost-matrix');
    },
    doSave ( ) {
      let self = this;

      if ( self.state == 'saving' ) {
        return;
      }

      let updateData = {};
      if ( !self.record ) {
        updateData = self.postData;
      }else{
        for(let field in self.postData){
          if ( self.postData[field] != self.record[field] )
            updateData[field] = self.postData[field];
        }
      }
      if (Object.keys(updateData).length == 0) {
        /* Nothing changes */
        self.$notify({
          type: 'success',
          text: 'Cost matrix record updated successfully.'
        });
        self.closeModal();
        return;
      }

      if (typeof updateData['category_id'] != "undefined" && !updateData['category_id']) {
        self.$notify({
          type: 'error',
          text: 'Please select the <strong>Category</strong>'
        });
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            if (typeof updateData['sell_basis'] != "undefined" && !updateData['sell_basis']) {
              self.$notify({
                type: 'error',
                text: 'Please select the <strong>Sell Basis</strong>'
              });
              return;
            }

            self.state = 'saving';
            if(self.record){
              ServiceCostMatrix.save(self.record.id, updateData, record => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Cost matrix record updated successfully.'
                });
                self.$emit('cost-matrix-saved', record);
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }else{
              ServiceCostMatrix.create(updateData, record => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Cost matrix record created successfully.'
                });
                self.$emit('cost-matrix-saved', record);
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }
          }
        });
    },
    log(message){
      window.console.log(message);
    }
  }
}
</script>
